// eslint-disable-next-line import/prefer-default-export
export const getUserSlug = (user) => user?.attributes?.profile?.publicData?.profileSlug;
